const getters = {
  // Auth
  token: state => state.user.token,
  loggedUser: state => state.user.loggedUser,
  // Monitor Vehicle 
  vehicles: state => state.vehicle.vehicles,
  selectedVehicle: state => state.vehicle.selectedVehicle,
  lastWaypointUpdateTime: state => state.vehicle.lastWaypointUpdateTime,
  // History
  isViewHistory: state => state.history.isViewHistory,
  isViewHistoryDetail: state => state.history.isViewHistoryDetail,
  tripReporting: state => state.history.tripReporting,
  historyFromDate: state => state.history.historyFromDate,
  historyToDate: state => state.history.historyToDate,
  // Notifications
  notifications: state => state.notification.notifications,
  news: state => state.notification.news,
  // Geofence
  geofences: state => state.geofence.geofences,
  selectedGeofence: state => state.geofence.selectedGeofence,
  isAddGeofence: state => state.geofence.isAddGeofence,
  isEditGeofence: state => state.geofence.isEditGeofence,
  addGeofenceRadius: state => state.geofence.addGeofenceRadius,
  addGeofenceLatLng: state => state.geofence.addGeofenceLatLng,
  // Maintenace
  maintenances: state => state.maintenance.maintenances,
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js